import PropTypes from 'prop-types'
import { TableRow, TableCell } from 'components/Table'
import { MenuButton, ChipPreRegistration } from 'components'
import helpers from 'helpers'
import constants from 'constants/index'
import { ActionButtons } from 'views/PreRegistrations/components'

const SublicensingsRow = ({ preRegistration, refresh }) => {
  return (
    <>
      <TableRow key={preRegistration?.id}>
        <TableCell>{preRegistration?.id}</TableCell>
        <TableCell>{preRegistration?.name}</TableCell>
        <TableCell>
          {preRegistration?.kind === constants.companies.KINDS.PERSONAL
            ? helpers.formatters.cpf(preRegistration?.document)
            : helpers.formatters.cnpj(preRegistration?.document)}
        </TableCell>
        <TableCell>{preRegistration?.quantityContracts}</TableCell>
        <TableCell>
          {helpers.formatters.currencyInput(preRegistration?.mmrAllContracts)}
        </TableCell>
        <TableCell disableTooltip>
          <ChipPreRegistration status={preRegistration?.status} />
        </TableCell>
        <TableCell disableTooltip align="right">
          <MenuButton>
            <ActionButtons
              preRegistration={preRegistration}
              refresh={refresh}
              isList
              typeClient={constants.preRegistration.SUBLICENSE_TYPE}
            />
          </MenuButton>
        </TableCell>
      </TableRow>
    </>
  )
}

SublicensingsRow.propTypes = {
  preRegistration: PropTypes.object,
}

export default SublicensingsRow
